export default "__VITE_ASSET__Cp_IgWtM__"